import React, {useEffect, useRef, useState} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../../[[...slug]]/index.page';
import {useDispatch, useSelector} from 'react-redux';
import {usePageSetting} from '~/providers/page-context.provider';
import EStoreDealEventOrganisms from '~/components/wrapper/organisms/store-deal-event-listing/store-deal-event-listing';
import productsApi from '~/pages/api/services/products-api';
import {handleFormatItemFilter, handleFormatProducts} from '../games/index.page';
import {
  addDealEventData,
  setDataFilter,
  setDealEventData,
  setEndCursor,
  setEndFeatured,
  setFilterItem,
  setFilterPrice,
  setSortBy,
  setSortItem,
  setTabListFilter,
  setTabSelect,
} from '~/redux-toolkit/dealEventSlice';
import {getGloablByType} from '~/utils/global-operations';
import {GetRouter, convertSlugToString, handleConvertToLocaleContentful} from '~/utils';
import {GLOBAL_TYPE} from '~/constants/content-map-type';

import getParamFilterBy, {handleFormatParamFilter} from '~/pages/games/get-param-filter-by';
import getListBrand from '~/pages/games/get-list-brand';
import * as Types from '../../../graphql/types';
import moment from 'moment';
import {Box} from '@mui/material';
import {handelFormatTitleStatus} from '~/components/wrapper/organisms/store-order-detail/store-order-detail';
import cookie from 'js-cookie';
import {BlockRenderer} from '~/components/renderer/block-renderer';

interface IDeal {
  data: any;
  dataBrand: any;
  seo: any;
  filterData: any;
  filterPrice: any;
  sortBy: any;
}

const Deal: React.FC<IDeal> = ({dataBrand, seo, filterData, filterPrice, sortBy}) => {
  const route = GetRouter();
  const {locale = '', query} = route;
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const dispatch = useDispatch();

  const tabSelect: number = useSelector((state: any) => state?.dealEventList?.tabSelect || 1);
  const tabListFilter: any[] = useSelector(
    (state: any) => state?.dealEventList?.tabListFilter || []
  );
  const sortItem: number = useSelector((state: any) => state?.dealEventList?.sortItem || 'NEWEST');
  const filterItem: any = useSelector((state: any) => state?.dealEventList?.filterItem || {});
  const productList: any = useSelector((state: any) => state?.dealEventList?.productData || []);
  const endCursor: any = useSelector((state: any) => state?.dealEventList?.endCursor || '');
  const endFeatured: any = useSelector((state: any) => state?.dealEventList?.endFeatured || false);

  const [id, setId] = useState<any>('');
  const [name, setName] = useState<any>('');
  const [title, setTitle] = useState<string>('');
  const [timeEvent, setTimeEvent] = useState<string>('');
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [isEmptyData, setIsEmptyData] = useState<boolean>(false);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  const refCallApi = useRef<any>(true);
  const refFirstDispatch = useRef<boolean>(true);
  const refTimeOutFirstLoad = useRef<any>();
  const refTimeOut = useRef<any>();
  const refPriceMax = useRef<number>(1000);

  const TypeTabFilter: any = {
    title: dataTranslation['filter-news-games'] || '',
    labelPill: dataTranslation['estore-products-tab-sort-filter'] || '',
    tabList: tabListFilter,
    titleSelect: 'all',
  };
  const handleReturnDateForLocal = (local: string, item: any) => {
    if (!item) {
      return '';
    }
    const newLocal = local.toLowerCase();
    switch (newLocal) {
      case 'hk-tc':
      case 'hk-sc':
        return moment(item).locale('zh-hk').format('MMM Do YYYY');
      case 'tw-tc':
      case 'tw-sc':
        return moment(item).locale('zh-tw').format('MMM Do YYYY');

      case 'ko-kr':
        return moment(item).locale('ko').format('MMM Do YYYY');

      default:
        return moment(item).locale('en-gb').format('D MMM YYYY');
    }
  };

  useEffect(() => {
    if (Object.keys(query).length && locale && !!Object.keys(dataTranslation).length) {
      const {id, st, et, deal} = query;
      if (window && id && deal) {
        window.clearTimeout(refTimeOut.current);
      } else {
        window.clearTimeout(refTimeOut.current);
        route.push(`/${route.locale}/store`);
      }
      setId((id as string) || '');
      let start = '';
      let end = '';
      if (!!st && st !== 'null') {
        const newStartDate = (st as string).split(' ')?.[0];
        start = handleReturnDateForLocal((locale as string) || '', (newStartDate as string) || '');
      }
      if (!!et && et !== 'null') {
        const newEndDate = (et as string).split(' ')?.[0];
        end = handleReturnDateForLocal((locale as string) || '', (newEndDate as string) || '');
      }
      const timeRang = `${start}${
        start && end ? ` ${dataTranslation['news-detail-date-range']} ` : ''
      }${end}`;

      const newTitle = handelFormatTitleStatus(convertSlugToString(deal as string) || '');
      setTitle(newTitle);
      setTimeEvent(timeRang);
      setName(deal);
    } else {
      refTimeOut.current = setTimeout(() => {
        route.push(`/${route.locale}/store`);
      }, 3000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, locale, dataTranslation]);

  // cleanup
  useEffect(() => {
    return () => {
      refCallApi.current = false;
    };
  }, []);

  // set data filter content
  useEffect(() => {
    const items = filterData?.items;
    const lengthBrands = !!dataBrand?.gameBrandCollection?.items.length;
    let result: {title: any; name: any; isChecked: boolean}[] = [];
    if (lengthBrands) {
      result = dataBrand?.gameBrandCollection?.items.map((item: any) => {
        return {
          title: item.title,
          name: item?.idForBig,
          isChecked: false,
        };
      });
    }
    if (items?.length) {
      const newFilter = handleFormatParamFilter(
        filterData as Types.FilterByCollection,
        dataTranslation || {}
      );
      const currencyCode = JSON.parse(cookie.get('currentValue') || '{"symbol":"S$"}');
      const newPrices = {
        countSelect: 0,
        dataFilter: filterPrice,
        showMore: false,
        title:
          dataTranslation['estore-products-title-filter-price'] +
          `${
            ['tc', 'ko-kr'].includes(`${locale}`.toLowerCase()) ? '' : ` (${currencyCode?.symbol})`
          }`,
        value: 'price',
        type: 'radio',
      };
      const newBrands = {
        countSelect: 0,
        dataFilter: result,
        showMore: false,
        title: dataTranslation['estore-filter-brands'],
        value: 'brand',
      };

      const newDataFilter = [...newFilter];
      if (lengthBrands) {
        newDataFilter.push(newBrands);
      }
      if (
        filterPrice?.length &&
        !['ko-kr', 'tc'].includes(`${locale}`.toLowerCase()) &&
        !['RM', 'Rp', '₱', '฿'].includes(currencyCode?.symbol)
      ) {
        refPriceMax.current = (filterPrice[filterPrice?.length - 2 || 0]?.name || 0) as number;
        newDataFilter.push(newPrices);
      }

      if (newDataFilter?.length) {
        dispatch(setDataFilter(newDataFilter));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, dataTranslation, filterPrice]);

  //set data sort & filter price
  useEffect(() => {
    if (sortBy?.length) {
      dispatch(setSortBy(sortBy));
    }
    if (filterPrice?.length) {
      dispatch(setFilterPrice(filterData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBy, filterPrice]);

  const handleSetData = (res: any, type?: string) => {
    const {data, meta} = res?.data;
    if (!id) {
      setId(res?.data?.id || '');
    }
    dispatch(setEndCursor(meta?.endCursor || ''));
    setHasNextPage(meta?.hasNextPage || false);
    if (meta?.endFeatured) {
      dispatch(setEndFeatured(true));
    }
    const newProducts = handleFormatProducts(data, dataTranslation || {}, locale);
    if (type === 'add') {
      dispatch(addDealEventData(newProducts));
    } else {
      dispatch(setDealEventData(newProducts));
      if (![...newProducts].length) {
        setIsEmptyData(true);
      }
    }
  };

  // get load more product
  const handleLoadMore = () => {
    if (productList?.length && hasNextPage) {
      productsApi
        .getListProductsDealEventDetail(
          {
            id,
            type: tabSelect,
            sort: sortItem,
            endCursor: endCursor,
            endFeatured: endFeatured,
            filter: handleFormatItemFilter(filterItem),
          },
          handleConvertToLocaleContentful(locale as string)
        )
        .then((res: any) => {
          if (res.status !== 200) {
            throw res;
          }
          handleSetData(res, 'add');
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  const handleChangeSelectTab = (v: any, callback?: () => void) => {
    dispatch(setTabSelect(v));
    setTimeout(() => {
      dispatch(setDealEventData([]));
      setHasNextPage(true);
    }, 300);
    setEndFeatured(false);
    setIsEmptyData(false);
    callback?.();
    const newFilter = handleFormatItemFilter(filterItem);
    productsApi
      .getListProductsDealEventDetail(
        {
          id: id,
          type: v,
          sort: sortItem,
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const handleFilter = (filter: any, sort: any, callback?: () => void) => {
    setIsEmptyData(false);
    setHasNextPage(true);
    dispatch(setSortItem(sort));
    dispatch(setDealEventData([]));
    callback?.();
    const newFilter = handleFormatItemFilter(filter);
    dispatch(setFilterItem(filter));

    productsApi
      .getListProductsDealEventDetail(
        {
          id: id,
          type: tabSelect,
          sort: sort || 'NEWEST',
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id && !tabListFilter?.length) {
      productsApi
        .getListProductsDealEventTab(id, handleConvertToLocaleContentful(locale as string))
        .then((res: any) => {
          if (res?.status !== 200) {
            throw res;
          }
          const {data} = res;
          const result: any[] = [
            {
              title: dataTranslation['estore-products-tab-all'] || '',
              value: 1,
            },
          ];
          if (data?.length) {
            data.map((item: any) => {
              const newItem = {
                title: item?.title || '',
                value: item?.id,
              };
              result.push(newItem);
            });
          }
          dispatch(setTabListFilter(result));
        })
        .catch(e => {
          console.log(e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  //get init productList
  useEffect(() => {
    if (!Object.keys(dataTranslation)?.length || !!productList.length || (!id && !name)) {
      return;
    }

    if (firstLoad && refFirstDispatch.current) {
      const newFilterItem = {
        genre: [...(filterItem?.genre || [])],
        price: filterItem?.price || [],
      };

      if (refTimeOutFirstLoad.current) {
        window.clearTimeout(refTimeOutFirstLoad.current);
      }

      refTimeOutFirstLoad.current = setTimeout(() => {
        refTimeOutFirstLoad.current = undefined;
        productsApi
          .getListProductsDealEventDetail(
            {
              id: id,
              name: name,
              type: tabSelect,
              sort: sortItem,
              filter: handleFormatItemFilter(newFilterItem),
            },
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res.status !== 200) {
              throw res;
            }
            handleSetData(res);
            refFirstDispatch.current = false;
            setFirstLoad(false);
          })
          .catch(() => {
            setFirstLoad(false);
          })
          .finally(() => {
            dispatch(setFilterItem(newFilterItem));
            refFirstDispatch.current = false;
          });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItem, firstLoad, dataTranslation, id, name]);

  const SeoStandard = seo?.deal
    ? {
        __typename: 'SeoStandard',
        ...seo.deal,
      }
    : null;

  return (
    <>
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <Box
        sx={{
          paddingTop: {
            xs: '72px',
            md: '80px',
          },
          paddingBottom: '40px',
        }}
      >
        <EStoreDealEventOrganisms
          hasNextPage={hasNextPage}
          onLoadMore={handleLoadMore}
          onlSelectTab={handleChangeSelectTab}
          onFilter={handleFilter}
          typeTabFilter={{
            ...TypeTabFilter,
            title: title,
            timeEvent: timeEvent,
          }}
          isEmptyData={isEmptyData}
          productList={productList}
        />
      </Box>
    </>
  );
};
export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [
    ReturnType<typeof getPageData>,
    ReturnType<typeof getListBrand>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getParamFilterBy>
  ] = [
    getPageData({slug: 'store', preview}, ctx),
    getListBrand(0, 20, handleConvertToLocaleContentful(ctx.locale as string), 'idForBig'),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.FilterPriceProducts
    ),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.SortByProducts
    ),
    getParamFilterBy(handleConvertToLocaleContentful((ctx.locale as string) ?? '')),
  ];
  const [pageData, dataBrand, seo, filterPrice, sortBy, filterData] = await Promise.all(promises);
  const {data} = pageData;
  return {
    props: {
      data,
      seo,
      dataBrand,
      filterPrice,
      sortBy,
      filterData,
    },
  };
};

export default Deal;
